import { connect } from 'react-redux';
import EmployersList from './EmployersList';
import { loadCompanyProfiles, deleteProfile } from 'actions/profile'
import {
  loadProfile, updateProfile, uploadPhoto, createProfile,
  loadAgentProfile, updateAgentProfile, uploadAgentPhoto
} from 'actions/profile'
const mapStateToProps = ({ profiles, profile: { tariff } }) => {
  const workersCount = profiles.data ? profiles.data.length : 0;
  const isEnoughMembers = tariff ? tariff.countPeople <= workersCount : false;

  return {
    profiles,
    isLoading: profiles.loading,
    workersCount,
    tariff,
    isEnoughMembers
  };
};

const mapDispatchToProps = {
  loadCompanyProfiles,
  deleteProfile,
  updateAgentProfile
};

// const mapDispatchToProps = {
//
// };

export default connect(mapStateToProps, mapDispatchToProps)(EmployersList);



// WEBPACK FOOTER //
// ./src/components/Profile/EmployersList/EmployersListContainer.js